<template>
    <div>
        <div class="ingresos">
            <h5>Ingresos</h5>
            <div class="table-responsive" v-if="entries.length">
                <table class="table table-sm table-hover table-bordered table-striped">
                    <thead class="thead-orange">
                        <tr class="x-d-flex">
                            <th>Fecha Ingreso</th>
                            <th>Estructura</th>
                            <th>Destino</th>
                            <th>Persona</th>
                            <th>Tipo de visitante</th>       
                            <th>Fecha de salida</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="entry in entries" class="x-d-flex">
                            <td>{{ entry.created_at }}</td>
                            <td>{{ entry.structure.name }}</td>
                            <td>{{ entry.destination.name }}</td>
                            <td><div v-if="entry.visited_person">{{ entry.visited_person.name }}</div></td>
                            <td>{{ entry.vehicle_entry_type.name }}</td>
                            <td>{{entry.completed_date}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="alert alert-danger" v-if="!entries.length">No se han registrado ingresos</div>
        </div>
    </div>
        
</template>
<script>
import vehicleRepository from '../../../../repositories/vehicles.repository.js';
export default {
    props: {
        plate: {
            type: String,
            required: true
        },
        clientId: {
            type: Number,
            required: true
        }

    },

    data(){
        return{
            entries: []
        };
    },

    watch: {
        plate(){
            this.loadEntries();
        }
    },

    methods: {
        loadEntries(){

            const vr = {...vehicleRepository};
            vr
                .getVehicleEntriesByClientAndVehicle(this.clientId, this.plate)
                .then(data => (this.entries = data.data))
                .catch(error => (toastr('Error al cargar las entradas del vehículo')));
        },
        cleanFields(){
            this.entries = [];
        }
    },

    created(){
        this.loadEntries();
        this.$bus.$on('vehicle-entry-history.clean', this.cleanFields);  
    }
    
}
</script>

